/**
 * 旅游产品模块接口
 * @description 产品详情、库存管理、产品订单等相关接口
 */

import axios, { GET, POST } from "@/utils/request";
import Api from "../api";
import * as Request from "../request.type";
import * as ResponseData from "../response.type";

/**
 * 获取入库旅游产品类型
 * @param data 旅游产品类型数据
 * @returns 旅游产品类型结果
 */
export const Http_getTicketsTypes = async () => {
  return await GET<ResponseData.TicketsType[]>(Api.GET_TICKETS_TYPES);
};

/**
 * 旅游销售产品详情
 */
export const Http_getTourProductDetails = async (
  /** 产品ID */
  params: Request.TourProductDetailsParams
) => {
  return await axios.get<ResponseData.TourProductDetails>(
    Api.GET_TOUR_PRODUCT_DETAILS,
    {
      params,
    }
  );
};

/**
 * 新增产品库存
 */
export const Http_postAddProductStock = async (
  params: Request.AddProductStockParams
) => {
  return await axios.post(Api.POST_ADD_PRODUCT_STOCK, params);
};

/**
 * 启用、禁用产品库存
 */
export const Http_postProductStockEnable = async (params: {
  stockId: number;
  status: number;
}) => {
  return await axios.post<any>(Api.POST_PRODUCT_STOCK_ENABLE, params);
};

/**
 * 启用、禁用产品库存票号
 */
export const Http_postProductStockNoEnable = async (params: {
  id: number;
  status: number;
}) => {
  return await axios.post<any>(Api.POST_PRODUCT_STOCK_NO_ENABLE, params);
};

/**
 * 作废产品库存
 */
export const Http_postProductStockInvalid = async (params: {
  stockId: number;
  nums: number;
}) => {
  return await axios.post<any>(Api.POST_PRODUCT_STOCK_INVALID, params);
};

/**
 * 全部产品
 */
export const Http_postTourProductAll = async (
  params: Request.TourProductAllParams
) => {
  return await axios.post(Api.POST_TOUR_PRODUCT_ALL, params);
};

/**
 * 获取打印门票url地址
 * @returns 获取打印门票
 */
export const Http_getApiTicket = async (
  /** 订单ID */
  id: number
) => {
  return await axios.get(Api.GET_APITICKET, {
    params: {
      id,
    },
  });
};

/**
 * 修改旅游产品订单供应商订单号
 */
export const Http_postOrderInfoUpdate = async (
  params: Request.ProdcutOrderInfoUpdateParams
) => {
  return await axios.post(Api.POST_PRODUCT_ORDER_INFO_UPDATE, params);
};

/**
 * 获取取卡串码
 */
export const Http_getProductPrintCardNo = async (
  /** 订单ID */
  id: number
) => {
  return await axios.get(Api.GET_PRODUCT_PRINT_CARD_NO, {
    params: {
      id,
    },
  });
};

/**
 * 获取旅游产品类型接口
 */
export const Http_getProductPackEdType = async () => {
  return await axios.get<ResponseData.ProductPackEdData[]>(
    Api.GET_PRODUCT_PACK_ED_TYPE
  );
};

/**
 * 获取旅游产品路线接口
 */
export const Http_getProductPackEdRoute = async () => {
  return await axios.get<ResponseData.ProductPackEdData[]>(
    Api.GET_PRODUCT_PACK_ED_ROUTE
  );
};

/**
 * 新增周期库存
 */
export const Http_postCreateCycleInventory = async (
  params: Request.CreateCycleInventoryParams
) => {
  return await axios.post(Api.POST_CREATE_CYCLEINVENTORY, params);
};

/**
 * 更新库存
 */
export const Http_postUpdateCycleInventory = async (
  params: Request.CreateCycleInventoryParams
) => {
  return await axios.post(Api.POST_UPDATE_CYCLEINVENTORY, params);
};

/**
 * 周期库存详情
 */
export const Http_postCycleInventoryDetail = async (params: { id: number }) => {
  return await axios.get(Api.POST_CYCLEINVENTORY_DETAIL, { params });
};

/**
 * 启用、禁用产品库存
 */
export const Http_postCycleInventoryStatus = async (params: {
  id: number;
  status: number;
}) => {
  return await axios.post<any>(Api.POST_CYCLEINVENTORY_STATUS, params);
};

/**
 * 查询可添加的产品列表
 */
export const Http_postAvailableProducts = async (params: {
  name: string /** 产品名称 */;
}) => {
  return await axios.post(Api.POST_AVAILABLE_PRODUCTS, params);
};

/**
 * 获取旅游产品订单详情
 * @param id 订单ID（支持数字或字符串）
 * @returns 旅游产品订单详情
 */
export const Http_getTourProductOrderInfo = async (
  /** 订单ID */
  id: number | string
) => {
  return await axios.get<ResponseData.TourProductOrderInfoData>(
    Api.GET_TOUR_PRODUCT_ORDER_INFO,
    {
      params: {
        id,
      },
    }
  );
};

/**
 * 获取旅游产品成本价
 * @description 获取旅游产品前15天和后60天的成本价格信息
 * @param productId 产品ID
 * @returns 成本价列表
 */
export const Http_getTourProductCostPrice = async (
  /** 产品ID */
  productId: number
) => {
  return await axios.get<ResponseData.TourProductCostPriceItem[]>(
    Api.GET_TOUR_PRODUCT_COST_PRICE,
    {
      params: {
        productId,
      },
    }
  );
};

// ==================== 旅游产品批量打包模块 ====================

/**
 * 旅游产品批量打包-新增
 * @param params 新增参数
 * @returns 新增结果
 */
export const Http_postTourProductPackBatchAdd = async (
  params: Request.TourProductPackBatchAddParams
) => {
  return await axios.post(Api.POST_TOUR_PRODUCT_PACK_BATCH_ADD, params);
};

/**
 * 旅游产品批量打包-修改
 * @param params 修改参数
 * @returns 修改结果
 */
export const Http_postTourProductPackBatchModify = async (
  params: Request.TourProductPackBatchModifyParams
) => {
  return await axios.post(Api.POST_TOUR_PRODUCT_PACK_BATCH_MODIFY, params);
};

/**
 * 旅游产品批量打包-详情
 * @param groupId 套餐ID
 * @returns 套餐详情
 */
export const Http_getTourProductPackBatchDetail = async (
  /** 套餐ID */
  groupId: number
) => {
  return await axios.get<ResponseData.PackBatchPackItem>(
    Api.GET_TOUR_PRODUCT_PACK_BATCH_DETAIL,
    {
      params: {
        groupId,
      },
    }
  );
};

/**
 * 获取NCNB城市列表
 */
export const Http_getNcnbCityList = async () => {
  return await axios.get<
    {
      /** 城市ID */
      id: number;
      /** 城市名称 */
      nameCn: string;
    }[]
  >(Api.GET_NCNB_CITY_LIST);
};
/**
 * 获取已绑定的酒店城市列表
 */
export const Http_getBindedHotelCityList = async () => {
  return await axios.get<
    {
      /** 城市ID */
      id: number;
      /** 城市名称 */
      nameCn: string;
    }[]
  >(Api.GET_HOTEL_CITY_LIST);
};

export interface HotelListByCityData {
  /** 酒店ID */
  hotelId: string;
  /** 酒店名称 */
  hotelName: string;
  /** 国家/地区ID */
  countryId: string;
  /** 国家/地区名称 */
  countryName: string;
  /** 省份ID */
  provinceId: string;
  /** 省份名称 */
  provinceName: string;
  /** 城市ID */
  cityId: string;
  /** 城市名称 */
  cityName: string;
  /** 地址 */
  address: string;
  /** 邮政编码 */
  postCode: string;
  /** 电子邮箱 */
  email: string;
  /** 开业时间 */
  startBusinessDate: string;
  /** 最后装修时间 */
  repairdate: string;
  /** 星级 */
  star: string;
  /** 经度 */
  lon: string;
  /** 纬度 */
  lat: string;
  /** 酒店评分 */
  score: string;
  /** 短描述/简介 */
  intro: string;
  /** 客户指引 */
  guide: string;
  /** 酒店电话 */
  hotelTel: string;
}

/**
 * 通过城市查询相关酒店列表
 */
export const Http_getHotelListByCity = async (params: {
  /** 城市ID */
  apiCityId: number;
}) => {
  return await axios.get<HotelListByCityData[]>(Api.GET_HOTEL_LIST_BY_CITY, {
    params,
  });
};

/**
 * 导入NCNB酒店信息
 */
export const Http_postImportNcnbHotel = async (params: {
  /** NCNB 城市ID */
  cityId: number;
  /** 酒店ID列表 */
  hotelIds: number[];
}) => {
  return await axios.post(Api.POST_IMPORT_NCNB_HOTEL, params);
};

/**
 * 获取供应商列表无分页版
 */
export const Http_getSupplierListNoPage = async () => {
  return await axios.get<ResponseData.HotelSupplierListData>(
    Api.GET_REPORT_SUPPLIER_TOUR_PRODUCT_SUPPLIER_LIST,
    { params: { page: 1, pageSize: 10000 } }
  );
};

/**
 * 旅游产品批量打包-分页查询
 * @param params 分页查询参数
 * @returns 分页列表
 */
export const Http_getTourProductPackBatchPage = async (
  params: Request.TourProductPackBatchPageParams
) => {
  return await axios.get<ResponseData.TourProductPackBatchPageData>(
    Api.GET_TOUR_PRODUCT_PACK_BATCH_PAGE,
    {
      params,
    }
  );
};

/**
 * 旅游产品批量打包-修改状态
 * @param groupId 批量打包分组ID
 * @param status 产品状态（1-启用，0-禁用）
 */
export const Http_postTourProductPackBatchStatus = async (params: {
  groupId: number;
  status: number;
}) => {
  return await axios.post(Api.POST_TOUR_PRODUCT_PACK_BATCH_STATUS, params);
};

/**
 * 批量查询打包商品的成本价，key 为 productId
 * @description 根据产品ID、路线、站点等信息批量查询打包商品的成本价
 * @param params 查询参数（包含 items 数组，每个 item 含 productId、routeId、tripType 等）
 * @returns 各产品成本价列表（以 productId 为 key）
 */
export const Http_postPackCostPriceBatchQuery = async (
  params: Request.PackCostPriceBatchQueryParams
) => {
  return await axios.post<ResponseData.PackCostPriceBatchQueryData>(
    Api.POST_TOUR_PRODUCT_PACK_COST_PRICE_BATCH_QUERY,
    params
  );
};

/**
 * 修改酒店启用/禁用状态
 */
export const Http_postModifyHotelStatus = async (params: {
  /** 酒店产品ID */
  id: number;
  /** 状态 */
  status: number;
}) => {
  return await axios.post(
    "/console/line/tour/product/hotelInfo/modifyStatus",
    params
  );
};

/**
 * 修改酒店产品启用/禁用状态
 */
export const Http_postModifyHotelPriceStatus = async (params: {
  /** 酒店产品ID */
  id: number;
  /** 状态 */
  status: number;
}) => {
  return await axios.post(
    "/console/line/tour/product/hotel/modifyStatus",
    params
  );
};

/** 酒店信息 */
export interface HotelListByCityIdData {
  /** 主键 */
  id: number;
  /** 酒店名称（简） */
  nameCn: string;
  /** 酒店名称（繁） */
  nameHk: string;
  /** 酒店名称（英） */
  nameEn: string;
  /** 所属城市ID */
  cityId: number;
  /** 经度 */
  longitude: string;
  /** 纬度 */
  latitude: string;
  /** 地址（简） */
  addressCn: string;
  /** 地址（繁） */
  addressHk: string;
  /** 地址（英） */
  addressEn: string;
  /** 联系方式 */
  contact: string;
  /** 供应商id */
  supplierId: number;
  /** 房源确定情况：0-等候确认,1-立即确认 */
  confirmationStatus: 0 | 1;
  /** 订单抬头 */
  orderPrefix: string;
  /** 有效开始日期 YYYY-MM-DD HH:mm:ss */
  validStartDate: string;
  /** 有效截止日期  YYYY-MM-DD HH:mm:ss */
  validEndDate: string;
  /** 酒店简介 */
  description: string;
  /** 酒店外观图片json字符串(内部字段) */
  exteriorImageStr: string;
  /** 酒店外观图片,文件路径json格式字符串 */
  exteriorImages: string[];
  /** 酒店外观图片url */
  exteriorImageUrls: string[];
  /** 酒店房型图片json字符串(内部字段) */
  roomTypeStr: string;
  /** 酒店房型图片,文件路径json格式字符串 */
  roomTypeImages: string[];
  /** 酒店房型图片url */
  roomTypeImageUrls: string[];
  /** 更新人 */
  updateBy: string;
  /** 更新时间  YYYY-MM-DD HH:mm:ss */
  updateTime: string;
  /** 数据状态：0-失效，1-有效 */
  status: 0 | 1;
}

/**
 * 通过城市id查询酒店列表
 */
export const Http_getHotelListByCityId = async (params: {
  /** 城市ID */
  apiCityId: number;
}) => {
  return await axios.get<HotelListByCityIdData[]>(
    Api.GET_HOTEL_LIST_BY_CITY_ID,
    { params }
  );
};

/**
 * 按酒店信息ID从 NCNB API 导入房型静态信息
 */
export const Http_postImportRoomTypeStaticInfo = async (params: {
  /** 酒店信息ID */
  hotelIds: number[];
}) => {
  return await axios.post(Api.POST_IMPORT_NCNB_ROOM, params);
};

/**
 * 查询酒店产品早餐类型列表
 */
export const Http_getBreakfastTypeList = async (hotelProductId: number) => {
  return await axios.get<
    {
      apiRatePlanId: string;
      code: string;
      name: string;
    }[]
  >(Api.GET_HOTEL_BREAKFAST_TYPE_LIST, {
    params: { hotelProductId },
  });
};

/**
 * 查询酒店房型组合
 */
export const Http_getHotelRoomCombinationList = async (
  /** 酒店信息ID */
  hotelIds: number[]
) => {
  return await axios.post<
    {
      /** 供应商房型ID */
      apiRoomId: string;
      /** 供应商价格计划ID */
      apiRatePlanId: string;
      /** 酒店名称 */
      hotelName: string;
      /** 房型名称 */
      roomName: string;
      /** 房型类型 */
      roomType: string;
      /** 房型类型名称 */
      roomTypeName: string;
      /** 床型 */
      bedType: string;
      /** 最大入住成人数 */
      maxAdult: number;
      /** 含早类型（本地系统编码） 0-不含早，1-单早，2-双早，3-含三早，4-2大1小自助早餐，5-含4早，6-2大2小早餐，7-含5早，8-含6早 */
      includedBreakfast: number;
      /** 含早名称 */
      includedBreakfastName: string;
      /** 价格计划名称 */
      ratePlanName: string;
      /** 参考价格（HKD，取明日价格；可能为null表示暂无价格） */
      hkdPrice: number;
      mopPrice: number;
      rmbPrice: number;
      /** 明日库存数量（-1表示暂无库存数据） */
      stock: number;
    }[]
  >(Api.GET_HOTEL_ROOM_COMBINATION, {
    hotelIds,
  });
};

/**
 * 导入酒店房型组合
 */
export const Http_postImportHotelRoomCombination = async (params: {
  /** 酒店信息ID */
  hotelInfoId: number;
  /** 房型组合列表 */
  items: {
    /** 供应商房型ID */
    apiRoomId: string;
    /** 供应商价格计划ID */
    apiRatePlanId: string;
  }[];
}) => {
  return await axios.post(Api.POST_IMPORT_HOTEL_ROOM_COMBINATION, params);
};

export interface TodayTourProductOrderData {
  /** 订单ID */
  orderId: number;
  /** 订单号 */
  orderNo: string;
  /** 产品名称 */
  productName: string;
  /** 下单时间 YYYY-MM-DD HH:ss */
  createTime: string;
  /** 订单状态描述 */
  statusDesc: "";
  /** 订单状态 11=待确认，1=已完成 */
  status: 1;
  /** 订单金额（扣除优惠券后的实付金额） */
  orderAmount: number;
  /** 订单金额 */
  amount: number;
  /** 优惠券金额 */
  couponAmount: number;
  /** 币种类型 */
  currencyType: number;
}

/**
 * 查询今日旅游产品订单统计
 */
export const Http_getTourProductOrderStatistics = async () => {
  return await axios.get<{
    /** 待确认订单状态统计 */
    pendingConfirmStateList: {
      count: number;
      list: TodayTourProductOrderData[];
    };
    /** 已完成订单状态统计 */
    completedStateList: {
      count: number;
      list: TodayTourProductOrderData[];
    };
  }>(Api.GET_TODAY_TOUR_PRODUCT_ORDER_STATISTICS);
};

// ==================== 西九文化区模块 ====================

/**
 * 查询API套票路线列表（按 packTypeCode 筛选）
 * @author Alfie
 */
export const Http_getPackRouteList = async (params: {
  packTypeCode: string;
}) => {
  return await GET<{ id: number; nameCn: string }[]>(
    Api.GET_PACK_ROUTE_SHORT_LIST,
    params
  );
};

/**
 * 查询API套票产品列表（按 packTypeCode 筛选）
 * @author Alfie
 */
export const Http_getPackProducts = async (params: {
  packTypeCode: string;
  routeId?: number | string;
  startDate?: string;
}) => {
  return await GET<{ id: number; nameCn: string }[]>(
    Api.GET_PACK_PRODUCTS,
    params
  );
};

/**
 * 查询套票产品价格及场次信息
 * @author Alfie
 */
export const Http_getPackProductInfo = async (params: {
  id: number;
  useDate: string;
}) => {
  return await GET<any>(Api.GET_TOUR_PRODUCT_DETAILS, params);
};

/**
 * 查询西九文化区子分类列表
 * @author Alfie
 */
export const Http_getWestkCategoryList = async () => {
  return await GET<ResponseData.WestkCategoryItem[]>(Api.GET_WESTK_CATEGORY);
};

/**
 * 查询西九文化区门票列表（单售）
 * @author Alfie
 */
export const Http_getWestkProducts = async (params: {
  /** 子分类 ID */
  categoryId: number;
  /** 使用日期，格式 yyyy-MM-dd */
  startDate: string;
}) => {
  return await GET<any[]>(Api.GET_WESTK_PRODUCTS, params);
};

/**
 * 后台-查询西九文化区可导入产品列表
 * @author Alfie
 */
export const Http_getWestkImportProducts = async () => {
  return await GET<ResponseData.WestkImportProductItem[]>(
    Api.GET_WESTK_IMPORT_PRODUCTS
  );
};

/**
 * 后台-确认导入选中的西九文化区产品
 * @author Alfie
 */
export const Http_postWestkImportConfirm = async (params: {
  productList: { programId: number; ticketTypeId: number }[];
}) => {
  return await POST<void, typeof params>(Api.POST_WESTK_IMPORT_CONFIRM, params);
};
